import { Injectable } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { ConfirmationDialogConfig, ConfirmationDialogData } from './models/confirmation-dialog.config';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
   constructor(private matDialog: MatDialog) {}

   confirm(dialogOptions: ConfirmationDialogConfig): MatDialogRef<ConfirmationDialogComponent, boolean> {
      if (!dialogOptions.data) {
         throw new Error('A confirmation message is required.');
      }

      if (!dialogOptions.panelClass) {
         dialogOptions.panelClass = dialogOptions.size;
      } else if (typeof dialogOptions.panelClass === 'string') {
         dialogOptions.panelClass = new Array<string>(dialogOptions.panelClass, dialogOptions.size);
      } else if (Array.isArray(dialogOptions.panelClass)) {
         dialogOptions.panelClass.push(dialogOptions.size);
      } else {
         dialogOptions.panelClass = dialogOptions.size;
      }

      dialogOptions.role = 'alertdialog';

      return this.matDialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(
         ConfirmationDialogComponent,
         dialogOptions
      );
   }

   closeAll() {
      this.matDialog.closeAll();
   }
}
